import * as React from 'react';
import { InlineChildren, InlineChildrenAlignment, InlineChildrenJustification, Text, TextColor, TextStyle, TextOverflow, IconColor, IconType, IconSize } from '@doordash/design-language';
import { MenuControlButton, RotatingMenuIcon } from './styles.js';
import { MenuSize, MenuCaretDirection } from './types.js';

var MenuControl = function MenuControl(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? MenuSize.Medium : _ref$size,
      _ref$isInline = _ref.isInline,
      isInline = _ref$isInline === void 0 ? true : _ref$isInline,
      text = _ref.text,
      describedBy = _ref.describedBy,
      isExpanded = _ref.isExpanded,
      _onClick = _ref.onClick,
      ariaControls = _ref['aria-controls'];
  return /*#__PURE__*/React.createElement(MenuControlButton, {
    "aria-describedby": describedBy,
    "aria-expanded": isExpanded,
    "aria-controls": ariaControls,
    size: size,
    isExpanded: isExpanded,
    isInline: isInline,
    onClick: function onClick(event) {
      return _onClick && _onClick(event);
    }
  }, /*#__PURE__*/React.createElement(InlineChildren, {
    alignItems: InlineChildrenAlignment.Center,
    justifyContent: InlineChildrenJustification.SpaceBetween
  }, /*#__PURE__*/React.createElement(Text, {
    color: TextColor.FieldsForegroundInactive,
    styles: TextStyle["Field".concat(size, "Input")],
    overflow: TextOverflow.Truncate
  }, text), /*#__PURE__*/React.createElement(RotatingMenuIcon, {
    color: IconColor.FieldsForegroundInactive,
    type: IconType.ChevronUp,
    size: IconSize.Medium,
    direction: isExpanded ? MenuCaretDirection.Up : MenuCaretDirection.Down
  })));
};

MenuControl.Sizes = MenuSize;

export { MenuControl as default };
